module.exports = __webpack_public_path__ + "img/KIT LC .f36d4909.jpg";